<div *ngIf="!isLoading else loadingView">
    <p-table [value]="dataSources" *ngIf="dataSources.length > 0 else noOpeningBalance"
             styleClass="p-datatable-gridlines">
        <ng-template pTemplate="header">
            <tr>
                <th class="cas-data-cell">
                    <span>LTM Items</span>
                </th>
                <th class="cas-data-cell">
                    <span>Opening Actual</span>
                </th>
                <th class="cas-data-cell">
                    <span>Year</span>
                </th>
                <th class="cas-data-cell">
                    <span> </span>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-record>
            <tr>
                <td class="cas-data-cell">
                    <span class="p-column-title">LTM Items</span>
                    <div class="cas-data-cell-data">{{record.maintenance_type_name}}</div>
                </td>
                <td class="cas-data-cell" *ngIf="!record.edit">
                    <span class="p-column-title">Opening Actual</span>
                    <div class="cas-data-cell-data">{{record.opening_balance_amount}}</div>
                </td>
                <td class="cas-data-cell" *ngIf="!record.edit">
                    <span class="p-column-title">Year</span>
                    <div class="cas-data-cell-data">{{record.opening_balance_year.name}}</div>
                </td>

                <td class="cas-data-cell" *ngIf="record.edit">
                    <input type="number" class="cas-edit-input" [(ngModel)]="record.opening_balance_amount">
                </td>
                <td class="cas-data-cell" *ngIf="record.edit">
                    <p-dropdown
                            appendTo="body"
                            [(ngModel)]="record.opening_balance_year"
                            [options]="years"
                            optionLabel="name"
                            placeholder="Select Year"
                            [filter]="true" scrollHeight="300px"
                    >
                    </p-dropdown>
                </td>
                <td>
                    <button class="cas-button-action" *ngIf="record.edit" (click)="saveState(record)">Update</button>
                    <button class="cas-button-action" *ngIf="!record.edit" (click)="toggleEdit(record)">Edit</button>
                    <button *ngIf="record.edit" (click)="closeEdit(record)">Cancel</button>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<ng-template #loadingView>
    <acabim-loading-view></acabim-loading-view>
</ng-template>

<ng-template #noOpeningBalance>
    <p class="cas-error-string">No opening balance item available</p>
</ng-template>
<p-toast position="center"></p-toast>
